var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5003 20.3959C15.9656 20.3959 20.3962 15.9654 20.3962 10.5001C20.3962 5.03476 15.9656 0.604248 10.5003 0.604248C5.03501 0.604248 0.604492 5.03476 0.604492 10.5001C0.604492 15.9654 5.03501 20.3959 10.5003 20.3959ZM18.8337 10.5001C18.8337 15.1025 15.1027 18.8334 10.5003 18.8334C5.89795 18.8334 2.16699 15.1025 2.16699 10.5001C2.16699 5.89771 5.89795 2.16675 10.5003 2.16675C15.1027 2.16675 18.8337 5.89771 18.8337 10.5001ZM11.2816 6.85425C11.2816 6.42278 10.9318 6.073 10.5003 6.073C10.0689 6.073 9.71908 6.42278 9.71908 6.85425V10.3699C9.71908 10.8733 10.1271 11.2813 10.6305 11.2813H15.1878C15.6193 11.2813 15.9691 10.9316 15.9691 10.5001C15.9691 10.0686 15.6193 9.71883 15.1878 9.71883H11.2816V6.85425Z",
    fill: "#3E3E4E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeIcon);
export default __webpack_public_path__ + "static/media/time-icon.1ade847139a5fbe8b31e0b04f03f521c.svg";
export { ForwardRef as ReactComponent };